export const CrawlPath = '/crawl';
export const CrawlUrls = {
  page: CrawlPath,
  person: `${CrawlPath}/person`
};
